import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  ID_TYPES_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  URLS,
  ZONE_FETCH_URL,
  UNSUPERVISED_WORKER_GROUP_URL,
} from "configs/constants";
import ReactSelect from "../../components/FormikControl/ReactSelect";
import { fetchDataFromApi } from "utils";
import * as Yup from "yup";
import eightAxios from "../../configs/axiosConfig";
import { useNotifyContext } from "../../components/Notify";
import { useHistory } from "react-router-dom";
import { PHONE_NUMBER_KEYS } from "configs/constants";
import { SOURCE_FETCH_URL } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";
import AllowableEstateDetails from "views/User/AllowableEstateDetails";


const initialValues = {
  id_type: "",
  id_number: "",
  name: "",
  username: "",
  role: [],
  mobile_number: "",
  office_number: "",
  employee_id: "",
  zone: "",
  source: "",
  company: "",
  region: "",
  estate: "",
  division: "",
  email: "",
  designation: "",
  department: "",
  is_hq: false,
  all_estates: false,
  allowables: [],
  worker_groups: [],
};

const validationSchema = Yup.object({
  employee_id: Yup.string()
    .required("Employee id is required")
    .typeError("Invalid employee id"),
  name: Yup.string()
    .required("Worker name is required")
    .typeError("Invalid employee name"),
  mobile_number: Yup.string()
    .required("Mobile Number is required")
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Mobile Number must not exceed 12 digits")
    .typeError("Invalid mobile number"),
  office_number: Yup.string()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .matches(/^[0-9]+$/, "Mobile Number must contain only digits")
    .matches(/^\S*$/, "Spaces at the beginning or end are not allowed")
    .min(8, "Invalid length Min 10, Max 12")
    .max(12, "Office Number must not exceed 12 digits")
  ,
  id_type: Yup.string()
    .required("ID type is required")
    .typeError("Invalid id type")
    .nullable(),
  id_number: Yup.string()
    .required("ID Number is required")
    .typeError("Invalid ID Number"),
  designation: Yup.string()
    .required("Designation is required")
    .typeError("Invalid designation"),
  role: Yup.array()
    .min(1, "No role selected")
    .required("User role/s is required")
    .typeError("Invalid role/s"),
  source: Yup.string()
    .required("Source is required")
    .typeError("Invalid source name")
    .nullable(),
  email: Yup.string().email("Invalid email address"),
  company: Yup.string()
    .required("Company is required")
    .typeError("Invalid company name")
    .nullable(),
  all_estates: Yup.boolean().required("All estates is required"),
  // zones: Yup.array().nullable().when("all_estates", {
  //     is: (all_estates) => !all_estates,
  //     then: Yup.array().min(1, "zones is a required field").required(),
  //     otherwise: Yup.array().notRequired(),
  //   }),
  // regions: Yup.array().when("all_estates", {
  //     is: (all_estates) => !all_estates,
  //     then: Yup.array().nullable().min(1, "regions is a required field").required(),
  //     otherwise: Yup.array().nullable().notRequired(),
  //   }),
  // estates: Yup.array().when("all_estates", {
  //     is: (all_estates) => !all_estates,
  //     then: Yup.array().nullable().min(1, "estates is a required field").required(),
  //     otherwise: Yup.array().nullable().notRequired(),
  //   }),
});

const API_URL = "new-user/";

const UserForm = () => {
  const [roles, setRoles] = useState([]);
  const history = useHistory();
  const [disableWorkerGroups, setDisableWorkerGroups] = useState(true);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableAllowableZones, setDisableAllowableZones] = useState(false);
  const [disableAllowableRegions, setDisableAllowableRegions] = useState(false);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [selectedRegions, setSelectedRegions] = useState('');
  const [regionClearValue, setRegionClearValue] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [clearWorkerGroups, setClearWorkerGroups] = useState(true);
  const [clearAllowables, setClearAllowables] = useState(true);
  const [workerGroupCheck, setWorkerGroupCheck] = useState(false);
  const [hasNotSupervisorValue, setHasNotSupervisorValue] = useState(false);
  const [hasNoEstates, setHasNoEstates] = useState(true);
  const [disableswitch, setDisableswitch] = useState(false);
  const [disableCompany, setDisableCompany] = useState(true);
  const [selectedErmlType, setSelectedErmlType] = useState(false);
  const [selectedAllowableType, setSelectedAllowableType] = useState(true)
  const [showAllowables, setShowAllowables] = useState(false);
  const [allowables, setAllowables] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [disableZone, setDisableZone] = useState(true);




  const [key, setKey] = useState(1);

  const setNotify = useNotifyContext();

  const handleWorkerGroupCheck = (
    e,
    disableWorkerGroups,
    setWorkerGroupCheck
  ) => {
    !e?.length && !disableWorkerGroups
      ? setWorkerGroupCheck(true)
      : setWorkerGroupCheck(false);
  };



  const getRoleValues = (e, setDisableWorkerGroups, setHasNotSupervisorValue) => {
    e
    if (!e) {
      setHasNotSupervisorValue(true);
      setDisableWorkerGroups(true);
    }
    let hasSuperVisor = e && e.filter(element => element.label.toLowerCase() === "supervisor");
    if (hasSuperVisor && hasSuperVisor.length <= 0) {
      setHasNotSupervisorValue(true);
      setDisableWorkerGroups(true);
      setWorkerGroupCheck(false);

    }
    else {
      setHasNotSupervisorValue(false);
      setDisableWorkerGroups(false);
      setWorkerGroupCheck(true);


    }


  };

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getErmlType = (e) => {

    if (e?.value == true) {
      setDisableswitch(true);

    }
    else {
      setDisableswitch(false);

    }
    setSelectedErmlType(e?.value);

  };
  const getZoneValues = (e, setDisableRegion) => {
  //  if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }

  };
  const getRegionValues = (e, setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }

  };

  const getEstateValues = (e, setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }

  };
  const getSourceValue = (e, setDisableCompany) => {
    if (!e || e.length === 0) {
      setDisableCompany(true);
    }
    else {
      setDisableCompany(false);
    }

  };
  useEffect(() => {

    if (selectedAllowableType == false) {
      setShowAllowables(true);
    } else {
      setShowAllowables(false);
    }


  }, [selectedAllowableType]);

  const getDivisonValues = (e, setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }

  };
  const getRegionsValues = (e) => {

    if (e && e.length > 0) {
      setDisableAllowableZones(true);
    } else {
      setDisableAllowableZones(false);
    }

    if (!e || e.length === 0) {
      setClearWorkerGroups(true);
    } else {
      setClearWorkerGroups(false);
    }

    setSelectedRegions(e);
  };

  const getEstatesValues = (e) => {

    if (e && e.length > 0) {
      setDisableAllowableRegions(true);
    } else {
      setDisableAllowableRegions(false);

    }

  };

  const getAllEstates = (e, setHasNoEstates, setClearAllowables) => {
    if (e?.value === true) {
      setSelectedAllowableType(true);  
      
      setHasNoEstates(true);
      setClearAllowables(false);
    } else {
      setSelectedAllowableType(false);
      
      setHasNoEstates(false);
      setClearAllowables(true);
    }

    setSelectedAllowableType(e?.value);
};
  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    if (selectedAllowableType) {
      setAllowables([]);
      setIsButtonDisabled(false);
    }
  }, [selectedAllowableType]);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  const handleSubmit = async (values, { setSubmitting }, checker) => {
    let submitVal = values;
    let keys = Object.keys(values);
    let data = new FormData();
    
    keys.forEach((key) => {
      if (Array.isArray(values[key])) {
        values[key].forEach((value) => {
          data.append(key, value);
        });
      } else {
        if (values[key] !== null) data.append(key, values[key]);
      }
    });
    const submitAllowables = allowables.filter(
      (allowables) => allowables.confirmed === true
    );

    if (submitAllowables.length === 0 && !values.all_estates) {
      setNotify({
        isOpen: true,
        message: "Please add at least one Allowables.",
        type: "error",
      });
      setSubmitting(false);
      return;
    }

 
    let notConfirmedAllowablesDetected = false;
    allowables.forEach((allowable) => {
      if (!allowable.confirmed) {
        notConfirmedAllowablesDetected = true;
      }
    });

    if (notConfirmedAllowablesDetected) {
      setNotify({
        isOpen: true,
        message:
          "Please confirm the unconfirmed record changes or remove the record.",
        type: "error",
      });
      setSubmitting(false);
      return;
    }
    
   

    if (values.regions == null) {
      values.regions = [];
    }
    submitVal["from_frontend"] = true;
    let apiKeys = Object.keys(submitVal);
    apiKeys.forEach((key) => {
      if (PHONE_NUMBER_KEYS.includes(key)) {
        if (typeof submitVal[key] === "string" && submitVal[key].trim() !== "") {
          if (submitVal[key].substring(0, 2) !== "60") {
            submitVal[key] = "60" + submitVal[key];
          }
        }
        else if (submitVal[key] === "") {
          submitVal[key] = null;
        }
      }
    });
    if (
      checker ||
      (!checker &&
        values?.worker_groups?.length &&
        values?.zone &&
        values?.region &&
        values?.estate)
    ) {
      for (let i = 0, valuePair; (valuePair = submitAllowables[i]); i++)
        for (let j in valuePair) data.append(j, valuePair[j]);

        
        var mappedallowables = submitAllowables.map(x => {return {zones : x.zones.value, regions : x.regions.value, estates: x.estates.value}} );
        values.allowables = mappedallowables;

      submitVal = data;
      eightAxios
        .post(`${API_URL}`, values)
        .then(async (response) => {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: "success",
          });
          setTimeout(function () {

            history.push(URLS.BO_LIST);
          }, 2000);

        })
        .catch((error) => {
          setNotify({
            isOpen: true,
            message: error.response.data.mobile_number || error.response.data.employee_id || error.response.data.id_number|| error.response.data.message ,
            type: "error",
          });
          setSubmitting(false);
        });
    } else {
      setNotify({
        isOpen: true,
        message:
          "Supervisor must be assigned zone, region, estate and worker group",
        type: "error",
      });
      setSubmitting(false);
    }
  };

  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "restricted",
      name: "employee_id",
      label: "Employee ID",
      regex: /[A-Za-z0-9]/i,
      required: true,
    },
    {
      type: "input",
      name: "name",
      label: "Employee Name",
      required: true,
    },
    {
      type: "input",
      name: "email",
      label: "Email",
    },
    {
      type: "phone",
      name: "mobile_number",
      label: "Mobile Number",
      required: true,
    },
    {
      type: "phone",
      name: "office_number",
      label: "Office Number",
    },

    {
      type: "reactselect",
      name: "id_type",
      label: "ID Type",
      required: true,
      proxyUrl: ID_TYPES_URL,
      paginated: true,
    },
    {
      type: "input",
      name: "id_number",
      label: "ID Number",
      required: true,
    },
    {
      type: "input",
      name: "designation",
      label: "Designation",
      required: true,
    },
    {
      type: "input",
      name: "department",
      label: "Department",
    },
    {
      name: "is_hq",
      key: "is_hq",
      type: "switch",
      label: "HQ?",
      gridSize: { xs: 12, sm: 6, md: 3, lg: 3 },

      color: "primary",
      labelLeft: "No",
      labelRight: "Yes",
      getValue: getErmlType,




    },
    {
      name: "api",
      key: "api",
      type: "switch",
      label: "API",
    //  disabled: disableswitch,
    disabled : true,
      gridSize: { xs: 12, sm: 6, md: 3, lg: 3 },

      color: "primary",
      labelLeft: "No",
      labelRight: "Yes",
      getValue: getErmlType,




    },
    {
      type: "reactselect",
      name: "source",
      label: "Source",
      proxyUrl: SOURCE_FETCH_URL,
      required: true,
      getValue: (e) => getSourceValue(e, setDisableCompany),

      paginated: true,
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      required: true,
      paginated: true,
      disabled: disableCompany,
      optionsDependsOn: "source",
      getValue: (e) => getCompanyValues(e, setDisableZone),



    },

    //FIXME: 10036 - Hide allowables for now
    // {
    //   name: "is_hq",
    //   label: "HQ?",
    //   type: "switch",
    //   labelLeft: "No",
    //   labelRight: "Yes",
    // },

    { type: "title", title: "Employment Details" },

    // {
    //   type: "reactselect",
    //   name: "role",
    //   label: "Roles",
    //   required: true,
    //   proxyUrl: ROLES_URL,
    //   paginated: true,
    //   discardOptionsByName: ["Worker"],
    //   isMultiSelect: true,
    // },
    {
      type: "component",
      name: "role",
      label: "Role",
      renderKey: "role",
      isMultiSelect: true,
      getValue: (e) => getRoleValues(e, setDisableWorkerGroups, setHasNotSupervisorValue, setWorkerGroupCheck),
      required: true,
      proxyUrl: ROLES_URL,
      isPaginationEnabled: false,
      isPageEnabled: 1,
      isPageSizeEnabled: 100,
      discardOptionsByName: ["Worker"],
      component: ReactSelect,
      gridSize: { xs: 12, sm: 6 },
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      optionsDependsOn: "company",
      disabled: disableZone,
      supervisorInfoIcon: true,

    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      disabled: disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      supervisorInfoIcon: true,

    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled: disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),
      supervisorInfoIcon: true,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled: disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled: disableBlock,

      optionsDependsOn: "division",
    },
    // {
    //   type: "reactselect",
    //   name: "worker_groups",
    //   label: "Worker Group",
    //   proxyUrl: UNSUPERVISED_WORKER_GROUP_URL,
    //   paginated: false,
    //   optionsDependsOn: "estate",
    //   isMultiSelect: true,
    // },
    {
      type: "reactselect",
      name: "worker_groups",
      label: "Worker Group",
      proxyUrl: UNSUPERVISED_WORKER_GROUP_URL,
      required: workerGroupCheck,
      getValue: (e) =>
        handleWorkerGroupCheck(e, disableWorkerGroups, setWorkerGroupCheck),

      disabled: disableWorkerGroups,
      clear: clearWorkerGroups,
      hasNotSupervisor: hasNotSupervisorValue,
      filterOnType: true,
      optionsDependsOn: "estate",
      paginated: false,
      isMultiSelect: true,
      gridSize: { xs: 12, sm: 6 },
    },

    //FIXME: 10036 - Hide allowables for now
    { type: "title", title: "Allowable Estate Details" },
    {
      name: "all_estates",
      label: "All Estates?",
      type: "switch",
      labelLeft: "No",
      labelRight: "Yes",
      gridSize: { xs: 12 },
      getValue: (e) => getAllEstates(e, setHasNoEstates, setClearAllowables),

    },
    {
      type: "component",
      component: AllowableEstateDetails,
      allowables: allowables,
      setAllowables: setAllowables,
      isButtonDisabled: isButtonDisabled,
      setIsButtonDisabled: setIsButtonDisabled,
      gridSize: { xs: 12 },
      showField: showAllowables,

    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  return (
    <Form
      key={key}

      validationSchema={validationSchema}
      initialValues={initialValues}
      submitUrl={API_URL}
      listRoute={URLS.BO_LIST}
      formFields={formFields}
      outerSubmitHandler={(values, { setSubmitting }) =>
        handleSubmit(values, { setSubmitting }, disableWorkerGroups)
      }
      formButtons={formButtons}
      formTitle="Back-Office User"
    />
  );
};

export default UserForm;
